import { render, staticRenderFns } from "./FileRenderer.vue?vue&type=template&id=46a9413c"
import script from "./FileRenderer.vue?vue&type=script&lang=js"
export * from "./FileRenderer.vue?vue&type=script&lang=js"
import style0 from "./FileRenderer.vue?vue&type=style&index=0&id=46a9413c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports